import { RenderedSpecialCondition } from '@urbanx/agx.campaigns.client';
import { DropdownOption } from '@urbanx/agx.ui-components2';
import { isValidSpecialConditionDueDate } from '../specialConditionDueDate';

const truncateText = (text: string | undefined, maxLength = 50): string => {
  const str = text || '';
  return str.length > maxLength ? `${str.substring(0, maxLength)}...` : str;
};

export const getSpecialConditionsOptions = (
  renderedSpecialConditions: RenderedSpecialCondition[] | undefined
): DropdownOption[] => [
  { label: '-', value: '' },
  ...((renderedSpecialConditions?.flatMap((condition) => {
    const directOption =
      condition.id && isValidSpecialConditionDueDate(condition.directDueDate)
        ? [
            {
              label: `${condition.position}: ${condition.title ?? ''}`,
              value: condition.id,
            },
          ]
        : [];

    return [
      ...directOption,
      ...(condition.clauses
        ?.filter((clause) => isValidSpecialConditionDueDate(clause.dueDate))
        .map((clause) => ({
          label: `Clause ${clause.clausePosition}: ${truncateText(clause.clauseText)}`,
          value: clause.clauseId ?? '',
        })) ?? []),
    ];
  }) as DropdownOption[]) ?? []),
];

export const useSpecialConditionsOptions = (
  renderedSpecialConditions: RenderedSpecialCondition[] | undefined
) => getSpecialConditionsOptions(renderedSpecialConditions);
